<!-- Copyright (c) 2023 Proto Labs, Inc. All Rights Reserved. -->

<template>
  <div class="identity-app">
    <router-view name="sidebar"></router-view>
    <div class="main">
      <notification-comp></notification-comp>
      <router-view></router-view>
    </div>
  </div>
</template>

<script lang="ts">
import notificationComp from '@/components/notification.vue';

export default {
  name: 'app',
  components: {
    notificationComp,
  },
};
</script>

<style lang="scss">
@import "@/styles/_layout.scss";

.identity-app {
  flex: 1 1 auto;
  backface-visibility: hidden;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 100%;
  position: relative;
  font-family: $font;
  height: 100%;
  background: $white;
  color: rgba(0,0,0,.87);

  .main {
      margin-left: $sidebar-width;
      height: 100%;
      @media screen and (max-width: 1200px) {
        margin-left: $sidebar-width-1200;
      }
      @media (max-width: 800px) {
        margin-left: $sidebar-width-800;
      }
  }
}
</style>
